import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Triple Hair consult
   */
  {
    // 1 Pregnancy question
    label: 'Are you pregnant or breastfeeding?',
    subLabel: '(Select at least one, or all that apply)',
    field: 'tripleHairPregnant',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'pregnant', value: 'I’m pregnant' },
        { key: 'breastfeeding', value: 'I’m breastfeeding' },
        { key: 'conceive', value: 'I’m trying to conceive' },
        { key: 'nonePregnant', value: 'None of the above', uncheckOthers: true }
      ]
    }
  },
  {
    // 2
    label: 'Was your assigned sex at birth?',
    field: 'tripleHairSex',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'male',
          value: 'Male'
        },
        {
          key: 'female',
          value: 'Female'
        }
      ]
    }
  },
  {
    // 3
    label:
      'Indicate the stage of hair thinning and loss you think you’re at using the scale below.',
    field: 'tripleHairNorwood',
    type: 'select',
    questionImage: 'https://cdn.buttercms.com/D0fqIWxhTPaQiOWxrkyZ',
    answer: {
      type: 'single_select',
      //  label: 'Indicate the stage of hair thinning and loss you think you’re at using the scale below.',
      // level: 'child',
      // questionImage: true,
      //   thirdWidth: true,
      options: [
        { key: 'tripleHair1', value: '1' },
        { key: 'tripleHair2', value: '2' },
        { key: 'tripleHair3', value: '3' },
        { key: 'tripleHair3V', value: '3 Vertex' },
        { key: 'tripleHair4', value: '4' },
        { key: 'tripleHair5', value: '5' },
        { key: 'tripleHair111', value: '6' },
        { key: 'tripleHairAdvanced', value: '7' }
      ]
    }
  },

  {
    // 3
    label:
      'Indicate the stage of hair thinning and loss you think you’re at using the scale below.',
    field: 'tripleHairLudwig',
    type: 'select',
    questionImage: 'https://cdn.buttercms.com/kk7goS1S2qFsIZ4X5RWE',
    answer: {
      type: 'single_select',
      //   label: 'Indicate the stage of hair thinning and loss you think you’re at using the scale below.',
      //  level: 'child',
      // questionImage: true,
      // thirdWidth: true,
      options: [
        { key: 'tripleHair1-1', value: '1-1' },
        { key: 'tripleHair1-2', value: '1-2' },
        { key: 'tripleHair1-3', value: '1-3' },
        { key: 'tripleHair1-4', value: '1-4' },
        { key: 'tripleHair11-1', value: '11-1' },
        { key: 'tripleHair11-2', value: '11-2' },
        { key: 'tripleHair111', value: '111' },
        { key: 'tripleHairAdvanced', value: 'Advanced' },
        { key: 'tripleHairFrontal', value: 'Frontal' }
      ]
    }
  },
  {
    // 4
    field: 'tripleHairOver18',
    label: 'Are you within 18 - 60 years of age?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'tripleHair18to60', value: 'Yes' },
        { key: 'tripleHairNo18to60', value: 'No' }
      ]
    }
  },
  {
    field: 'tripleHairAcknowledgement',
    label:
      'To be a part of this program: - you promise to use the medication as prescribed and at the required dosage - you have to speak with a member of our team for the program onboarding and to schedule short conversations every month to discuss your hair growth progression and provide us with updated photos. - you’ll also need to provide us with a written testimonial about the experience you had during the 4 months. We’ll throw in some extra goodies if you’re up for filming a short 20 second review!\nDo you agree? ',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'tripleHairAcknowledgement',
          value:
            'Yes - I agree with the above terms and would like to be a part of the beta program to receive 4 months of free products. I understand the implications of the terms and conditions to be eligible for this treatment.'
        }
      ]
    }
  }
];

export default questionsModels;
